import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";

import Breadcrumb from './Breadcrumb';
import LoadingBar from './LoadingBar';
import FrontPage from './FrontPage';
import config from './../../config';
import { Helmet } from 'react-helmet';
import helpers from '../../lib/helpers';

class PageView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/pages/';

		this.htmlContentClickHandler = this.htmlContentClickHandler.bind(this);

		this.state = {
			initialized: false,
			loading: true
		};

		window.eventBus.addEventListener('Lang.languageChanged', function() {
			this.fetchData();
		}.bind(this));

		window.eventBus.addEventListener('Lang.languageDataUpdate', function() {
			this.fetchData();
		}.bind(this));
	}

	componentDidMount() {
		if (this.props.location || this.props.url) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		// Athuga hvort breytur hafi breyst og hvort component eigi að uppfærast
		if (this.props.location && this.props.location.pathname != prevProps.location.pathname) {
			this.setState({
				data: null,
				willRefresh: true
			}, function() {
				this.fetchData();
			}.bind(this));
		}

		if (!this.state.willRefresh && this.refs.htmlContainer) {
			let tables = this.refs.htmlContainer.getElementsByTagName('table');

			for (var i = 0; i < tables.length; i++) {
				tables[i].classList.add('table');
				tables[i].classList.add('table-responsive');
			}
		}
	}

	isExternal(url) {
		var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
		if (url.toLowerCase().indexOf('.pdf') > -1) return true;
		if (url.startsWith('https://') || url.startsWith('http://')) return true;
		if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== window.location.protocol) return true;
		if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":("+{"http:":80,"https:":443}[window.location.protocol]+")?$"), "") !== window.location.host) return true;
		return false;
	}

	htmlContentClickHandler(event) {
		let linkEl = event.target.closest('a');

		if (linkEl) {
			let linkUrl = linkEl.getAttribute('href');

			if (!this.isExternal(linkUrl) && (!linkEl.getAttribute('target'))) {
				event.preventDefault();
				this.props.history.push(linkUrl);
			}
		}
	}

	fetchData() {
		if (!this.props.url) {
			window.scrollTo(0, 0);
		}

		this.setState({
			loading: true
		});

		let path = this.props.url ? this.props.url : this.props.location.pathname;

		let urlParams = [];
		urlParams.push('url='+path);

		urlParams.push('lang='+(window.currentLang || 'is'));

		// Sæki gögn til APA
		fetch(this.url+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json.results[0],
					willRefresh: false,
					notFound: json.results.length == 0,
					loading: false
				});

				if (json.results[0] && json.results[0].title) {
					window.document.title = config.siteTitle+' | '+json.results[0].title;
				}

				setTimeout(function() {
					this.setState({
						initialized: true
					});
				}.bind(this), 200);
			}.bind(this));
	}

	formatHtml(html) {
		let formatedHtml = html.replace(/\\r|\\n/g, '');

		return formatedHtml;
	}

	render() {
		let dataItem = this.state.data || null;

		return (
			<div className={(!this.props.url ? 'content-container' : '')+' page-container position-relative manual-init'+(dataItem && dataItem.frontpage && dataItem.url == '/' ? ' front-page' : '')+(this.state.initialized ? ' initialized' : '')+(this.state.loading ? ' loading' : '')}>
				<LoadingBar />
				{
					dataItem && !dataItem.frontpage &&
					dataItem &&
					<React.Fragment>
						<Helmet>
							<meta property="og:type"
								content="article"
							/>
							<meta property="og:title"
								content={'Ísmús | '+dataItem.title}
							/>
							<meta property="og:description"
								content={helpers.trim(this.formatHtml(dataItem.content), 600)}
							/>
							<meta property="og:image" content='//ismus.is/img/share-image.png' />
						</Helmet>

						<div className={dataItem.url != '/' ? 'page-content' : ''}>
							{
								!this.props.url &&
								<Breadcrumb currentElTitle={dataItem.title} />
							}
							{
								dataItem.url != '/' &&
								<h2>{dataItem.title}</h2>
							}
							<div className="html-content"
								ref="htmlContainer"
								onClick={this.htmlContentClickHandler}
								dangerouslySetInnerHTML={{__html: this.formatHtml(dataItem.content)}} />
							</div>
					</React.Fragment>
				}
				{
					dataItem && dataItem.frontpage &&
					<React.Fragment>
						{
							dataItem.url != '/' &&
							<Breadcrumb currentElTitle={dataItem.title} />
						}
						<FrontPage url={dataItem.url || '/'} />
					</React.Fragment>
				}
				{
					this.state.notFound && !this.props.url &&
					<div className="page-content text-center">
						<h2>Síða finnst ekki</h2>
						<p>Engin síða finnst á slóðinni <strong>{this.props.history.location.pathname}</strong>.</p>
					</div>
				}
				{
					this.state.notFound && this.props.fallback
				}
			</div>
		);
	}
}

export default withRouter(PageView);
